import { createContext, useEffect, useState } from "react";

export const AdministratorReportContentContext = createContext();

const initialReportContentState = {
  staffGrantInAid: "",
  staffSelfSupporting: "",
  aicteApproval:"",
  auAffiliation:"",
  report:"",
};

export const STAFF_GRANT_IN_AID = "staffGrantInAid";
export const STAFF_SELF_SUPPORTING = "staffSelfSupporting";
export const AICTE_APPROVAL = "aicteApproval";
export const AU_AFFILIATION = "auAffiliation";
export const REPORT = "report";

export const AdministratorReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <AdministratorReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </AdministratorReportContentContext.Provider>
  );
};
